'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import { getUrlOverrides, LDFlags, toFlagsCamelCase } from '@/consts/LDFlags';

export const useLDFlags = (): LDFlags => {
  // NOTE: LaunchDarkly React SDK converts keys to camelCase
  const ldFlags = useFlags();
  const searchParams = useSearchParams();

  return useMemo(() => {
    const urlOverrides = toFlagsCamelCase(getUrlOverrides(searchParams));

    return { ...ldFlags, ...urlOverrides } as LDFlags;
  }, [ldFlags, searchParams]);
};
